import React, { FC } from 'react'
import type { RowsPerPageCount, RowsPerPageProps } from './types'
import { ROW_SIZE } from './constants'
import { Typography } from '../../../Typography'

export const RowsPerPage: FC<RowsPerPageProps> = ({
  rowsPerPage = 25,
  onChangeRowCount,
}) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = parseInt(event.target.value, 10)
    onChangeRowCount?.(newValue as RowsPerPageCount)
  }

  return (
    <div className="flex items-center gap-x-1.5">
      <label htmlFor="rowsPerPage">
        <Typography size="sm" weight="medium" className="text-subtle">
          Rows per page
        </Typography>
      </label>
      <select
        id="rowsPerPage"
        name="rowsPerPage"
        className="cursor-pointer bg-transparent"
        value={rowsPerPage}
        onChange={handleOnChange}
        data-testid="pagination-rows"
      >
        {ROW_SIZE.map((size) => (
          <option
            className="text-sm font-semibold text-default"
            key={`row-size-option-${size}`}
            value={size}
          >
            {size}
          </option>
        ))}
      </select>
    </div>
  )
}

export default RowsPerPage
